module.exports = __webpack_public_path__ + "img/right-arrow-blue.a7a6757e.svg";